import { NavLink } from "react-router";
import { useApp } from "../container";
import { useLocale } from "../i18n/LocaleProvider";
import styles from "./TabBar.module.css";

const icons = {
  today: "M12 3v2M12 19v2M3 12h2M19 12h2M5.6 5.6l1.4 1.4M17 17l1.4 1.4M5.6 18.4 7 17M17 7l1.4-1.4M12 8a4 4 0 1 0 0 8 4 4 0 0 0 0-8z",
  calendar: "M5 5h14a1 1 0 0 1 1 1v13a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1zM4 10h16M8 3v4M16 3v4",
  reports: "M4 20V10M10 20V4M16 20v-7M22 20H2",
  settings: "M12 8a4 4 0 1 0 0 8 4 4 0 0 0 0-8zM4 12h2M18 12h2M12 4v2M12 18v2M6.3 6.3l1.4 1.4M16.3 16.3l1.4 1.4M6.3 17.7l1.4-1.4M16.3 7.7l1.4-1.4",
};

function Icon({ d }: { d: string }) {
  return (
    <svg className={styles.icon} viewBox="0 0 24 24" aria-hidden="true">
      <path d={d} fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

export function TabBar() {
  const app = useApp();
  const { t } = useLocale();
  return (
    <nav className={styles.bar}>
      <NavLink to="/" onClick={() => app.analytics.track("tab_click", { tab: "today" })} end className={styles.tab}><Icon d={icons.today} />{t.tabs.today}</NavLink>
      <NavLink to="/calendar" onClick={() => app.analytics.track("tab_click", { tab: "calendar" })} className={styles.tab}><Icon d={icons.calendar} />{t.tabs.calendar}</NavLink>
      <NavLink to="/reports" onClick={() => app.analytics.track("tab_click", { tab: "reports" })} className={styles.tab}><Icon d={icons.reports} />{t.tabs.reports}</NavLink>
      <NavLink to="/settings" onClick={() => app.analytics.track("tab_click", { tab: "settings" })} className={styles.tab} aria-label={t.tabs.settings}><Icon d={icons.settings} />{t.tabs.settings}</NavLink>
    </nav>
  );
}
